"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isPhoneNumber = void 0;
function isPhoneNumber(value, options) {
    var isValid = true;
    var errors;
    var phoneNumberRegex;
    var required = options && options.required !== undefined ? options.required : true;
    if (options === null || options === void 0 ? void 0 : options.formatted) {
        phoneNumberRegex = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im;
    }
    else {
        phoneNumberRegex = /^\+[0-9]{7,15}$/;
    }
    return (required && !value) || (value && !value.match(phoneNumberRegex))
        ? {
            isValid: false,
            errors: {
                value: value,
                constraints: {
                    isValidPhoneNumber: "false",
                },
            },
        }
        : {
            isValid: isValid,
            errors: errors,
        };
}
exports.isPhoneNumber = isPhoneNumber;
